var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { Translate } from "../../../../../I18N";
import { Button, Modal } from "../../../../Components/UI";
import { MultiselectList } from "../../../../Components/Forms";








const AddTemplatesModal = ({ onCancel, onAdd, templates }) => {
  const [selected, setSelected] = useState([]);

  const items = templates === null || templates === void 0 ? void 0 : templates.map((template) => ({
    label: template.name,
    value: template._id,
    searchLabel: template.name
  }));

  return /*#__PURE__*/(
    _jsx(Modal, { size: "lg" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add entity type")
    ), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: () => onCancel(false) })
    ), /*#__PURE__*/
    _jsx(Modal.Body, { className: "pt-4" }, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      className: "pt-4 max-h-96",
      items: items || [],
      onChange: (s) => setSelected(s) }
    )
    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => onCancel(false), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      onClick: async () => {
        onCancel(false);
        onAdd(selected);
      },
      className: "grow",
      disabled: !selected.length }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add"), " ", selected.length ? `(${selected.length})` : ''
    )
    )
    )
    )
    ));

};

export { AddTemplatesModal };